/**
 * hamburger
 */
export function humburger_menu() {
  const hamButton = document.getElementById('hamburger-button');
  const humHeader = document.getElementById('site-header');
  const humBody = document.getElementById('body');
  const hamDrawer = document.getElementById('drawer');
  const closeInDrawer = document.getElementById('close-drawer');

  if (!hamButton || !hamDrawer) return;

  const openDrawer = () => {
    hamButton.classList.add('is-open');
    humHeader?.classList.add('is-open');
    humBody?.classList.add('is-locked');
    hamDrawer.setAttribute('aria-hidden', 'false');
  };

  const closeDrawer = () => {
    hamButton.classList.remove('is-open');
    humHeader?.classList.remove('is-open');
    humBody?.classList.remove('is-locked');
    hamDrawer.setAttribute('aria-hidden', 'true');
  };

  const toggleDrawer = () => {
    const isOpen = hamDrawer.getAttribute('aria-hidden') === 'false';
    if (isOpen) {
      closeDrawer();
    } else {
      openDrawer();
    }
  };

  hamButton.addEventListener('click', toggleDrawer);

  if (closeInDrawer) {
    closeInDrawer.addEventListener('click', closeDrawer);
  }

  const drawerLinks = hamDrawer.querySelectorAll('a[href^="#"], a[href^="/#"]');

  drawerLinks.forEach((link) => {
    link.addEventListener('click', closeDrawer);
  });
}

/**
 * drawer submenu
 */
export function drawer_menu() {
  const drawer = document.getElementById('drawer');
  if (!drawer) return;

  /**
   * 第一階層
   * li[data-has="has-submenu"] > span クリックで開閉
   */
  const drawerParents = drawer.querySelectorAll('li[data-has="has-submenu"]');

  drawerParents.forEach((parent, index) => {
    const trigger = parent.querySelector(':scope > span, :scope > button');
    const submenu = parent.querySelector(':scope > .p-submenu');

    if (!trigger || !submenu) return;

    submenu.id = `drawer-submenu-${index}`;
    submenu.hidden = true;

    // accessibility
    trigger.setAttribute('role', 'button');
    trigger.setAttribute('tabindex', '0');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-controls', submenu.id);

    const toggle = () => {
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';

      trigger.setAttribute('aria-expanded', String(!isOpen));
      parent.classList.toggle('is-open', !isOpen);
      submenu.hidden = isOpen;
    };

    // click
    trigger.addEventListener('click', toggle);

    // keyboard
    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle();
      }
    });
  });

  /**
   * WordPressの子メニュー
   * .menu-item-has-children はボタン追加
   */
  // const wpParents = drawer.querySelectorAll('.menu-item-has-children');

  // wpParents.forEach((parent, index) => {
  //   const link = parent.querySelector(':scope > a');
  //   const subMenu = parent.querySelector(':scope > .sub-menu');

  //   if (!link || !subMenu) return;

  //   const button = document.createElement('button');
  //   button.type = 'button';
  //   button.className = 'p-drawer__child-button';
  //   button.setAttribute('aria-expanded', 'false');
  //   button.setAttribute('aria-controls', `drawer-child-submenu-${index}`);
  //   button.innerHTML = '<span class="screen-reader-text">開閉</span>';

  //   subMenu.id = `drawer-child-submenu-${index}`;
  //   subMenu.hidden = true;

  //   link.after(button);

  //   button.addEventListener('click', () => {
  //     const isOpen = button.getAttribute('aria-expanded') === 'true';

  //     button.setAttribute('aria-expanded', String(!isOpen));
  //     parent.classList.toggle('is-open', !isOpen);
  //     subMenu.hidden = isOpen;
  //   });
  // });
}